'use strict';

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

var StripeDecorator = /*#__PURE__*/function (_React$Component) {
  _inherits(StripeDecorator, _React$Component);

  var _super = _createSuper(StripeDecorator);

  function StripeDecorator() {
    var _this;

    _classCallCheck(this, StripeDecorator);

    _this = _super.call(this);
    _this.state = {
      Wrapper: null
    };
    return _this;
  }

  _createClass(StripeDecorator, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var stripePublicKey = this.props.stripePublicKey;
      Promise.all([Promise.resolve().then(function () { return /*#__PURE__*/_interopNamespace(require('@stripe/react-stripe-js')); }), Promise.resolve().then(function () { return /*#__PURE__*/_interopNamespace(require('@stripe/stripe-js')); })]).then(function (data) {
        var _data$ = data[0],
            Elements = _data$.Elements,
            ElementsConsumer = _data$.ElementsConsumer,
            rest = _objectWithoutProperties(_data$, ["Elements", "ElementsConsumer"]);

        var loadStripe = data[1].loadStripe;
        var stripePromise = loadStripe(stripePublicKey);

        _this2.setState(Object.assign({}, rest, {
          Wrapper: function Wrapper(props) {
            return /*#__PURE__*/React__default['default'].createElement(Elements, {
              stripe: stripePromise
            }, /*#__PURE__*/React__default['default'].createElement(ElementsConsumer, null, function (_ref) {
              var stripe = _ref.stripe,
                  elements = _ref.elements;
              return React__default['default'].cloneElement(props.children, Object.assign({
                stripe: stripe,
                elements: elements
              }, props));
            }));
          }
        }));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          Wrapper = _this$state.Wrapper,
          rest = _objectWithoutProperties(_this$state, ["Wrapper"]);

      if (!Wrapper) {
        return null;
      }

      return /*#__PURE__*/React__default['default'].createElement(Wrapper, _extends({}, this.props, rest));
    }
  }]);

  return StripeDecorator;
}(React__default['default'].Component);

module.exports = StripeDecorator;
